<template>
    <input
        type="file"
        class="hidden"
        ref="fileInput"
        name="company_first_image"
        :accept="['image/jpeg', 'image/png'].join(', ')"
        @input="setImage('company_first_image', $event)" />
</template>

<script>
    export default {
        props: {
            maxSize: {
                type: Number,
                default: 2, // in MB
            },
        },
        methods: {
            triggerFileInputDialog(skipCropper = false) {
                this.skipCropper = skipCropper;
                this.$refs.fileInput.click()
            },

            setImage(name, event) {
                const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
                const files = event.target.files || event.dataTransfer.files;

                if (!files.length) {
                    return;
                }

                if (files[0].type.indexOf('image/') === -1) {
                    alert('Please select an image file');
                    return;
                }

                const { name:fileName, size:fileSize } = files[0];
                const fileExtension = fileName.split('.').pop();

                // MB * KB * BYTES = 2000000 (2mb)
                const maxSize = this.maxSize * 1000 * 1000;

                if (fileSize >= maxSize) {
                    alert('Oups... Bilden är större än 2MB. Var snäll och ladda upp en mindre bild.');
                    return;
                }

                const image = new Image();
                const reader = new FileReader();

                reader.onload = (e) => {
                    // this.form[name] = e.target.result;
                    // this.$refs.cropper.replace(e.target.result);
                    this.$emit('update:modelValue', files[0])
                    this.$emit('imageSelected', e.target.result, files[0]);
                }

                reader.readAsDataURL(files[0]);
            }
        }
    }
</script>
